const LAST_ROUTE_KEY = "lastVisitedRoute";
const BACK_NAV_KEY = "backNavCount";

const EXCLUDED_PREFIXES = ["/onboarding"];

export function saveLastRoute(path: string, search = "") {
  const isExcluded = EXCLUDED_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(prefix + "/"),
  );
  if (!isExcluded) {
    sessionStorage.setItem(LAST_ROUTE_KEY, path + search);
  }
}

export function getLastRoute(): string | null {
  return sessionStorage.getItem(LAST_ROUTE_KEY);
}

export function clearLastRoute() {
  sessionStorage.removeItem(LAST_ROUTE_KEY);
}

export function markBackNavigation() {
  const current = parseInt(sessionStorage.getItem(BACK_NAV_KEY) || "0");
  sessionStorage.setItem(BACK_NAV_KEY, String(current + 1));
}

export function consumeBackNavigation(): boolean {
  const current = parseInt(sessionStorage.getItem(BACK_NAV_KEY) || "0");
  if (current > 0) {
    sessionStorage.setItem(BACK_NAV_KEY, String(current - 1));
    return true;
  }
  return false;
}

export function clearNavIntent() {
  sessionStorage.removeItem(BACK_NAV_KEY);
}
